import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import { Alert, Card, CardContent, CardHeader, Divider, Link, Stack } from '@mui/material';
import { useAppSelector } from '../../../store/hooks';
import ConnectGoogleAccount from './ConnectGoogleAccount/ConnectGoogleAccount';
import DeleteMyGoogleData from './DeleteMyGoogleData/DeleteMyGoogleData';
import DisconnectGoogleAccount from './DisconnectGoogleAccount/DisconnectGoogleAccount';
import SubscribeToWebhook from './SubscribeToWebhook/SubscribeToWebhook';
import UnsubscribeFromWebhook from './UnsubscribeFromWebhook/UnsubscribeFromWebhook';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        margin: theme.spacing(2),
    },
    header: {
        position: 'relative',
        padding: theme.spacing(2),
        '& > h3': {
            textTransform: 'capitalize',
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            display: 'block',
            width: '100%',
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
    },
    list: {
        padding: theme.spacing(2),
    },
    linkText: {
        //color: theme.palette.common.white
    },
    error: {
        color: 'red',
        padding: theme.spacing(2),
    },
}));

export default function GoogleSettings() {
    const { classes } = useStyles();

    const userGoogleAccountId = useAppSelector(state => state.user.googleAccountId || null);
    const googleCalendarChannelId = useAppSelector(
        state => state.user.googleCalendarChannelId || null,
    );
    const googleSessionExpired = useAppSelector(state => state.user.googleSessionExpired);

    return (
        <>
            <Card>
                <CardHeader title="Google Account" />
                <Divider />
                <CardContent>
                    <Stack spacing={2} alignItems="flex-start">
                        {!!userGoogleAccountId && <DisconnectGoogleAccount />}
                        {!userGoogleAccountId && <ConnectGoogleAccount />}
                        {!!userGoogleAccountId && googleSessionExpired && (
                            <>
                                <Alert severity="error">
                                    We have detected your Google Connection has expired. Please
                                    reconnect to re-establish synchronization.{' '}
                                </Alert>
                                <ConnectGoogleAccount />
                            </>
                        )}
                        <Typography>
                            Please refer to our{' '}
                            <Link
                                href="https://stayincontact.com/eula"
                                target="blank"
                                className={classes.linkText}
                            >
                                Terms of Service
                            </Link>{' '}
                            and{' '}
                            <Link
                                href="https://consulnet.com/privacy"
                                target="blank"
                                className={classes.linkText}
                            >
                                Privacy Policy
                            </Link>{' '}
                            for more information.
                        </Typography>
                    </Stack>
                </CardContent>
            </Card>
            {!!userGoogleAccountId && (
                <Card>
                    <CardHeader title="Google Calendar Two-Way Event Synchronization" />
                    <CardContent>
                        <Stack spacing={2} alignItems="flex-start">
                            <Typography component="p" variant="body2">
                                Synchronization:{' '}
                                <strong>{googleCalendarChannelId ? 'Enabled ' : 'Disabled'}</strong>
                            </Typography>
                            {!googleCalendarChannelId && <SubscribeToWebhook />}
                            {!!googleCalendarChannelId && <UnsubscribeFromWebhook />}
                        </Stack>
                    </CardContent>
                </Card>
            )}
            <DeleteMyGoogleData />
        </>
    );
}
